// extracted by mini-css-extract-plugin
export var avatarContainer = "_8d-0";
export var avatarTypingWave = "_8d-i";
export var gray = "_8d-f";
export var green = "_8d-c";
export var icon = "_8d-9";
export var image = "_8d-1";
export var lg = "_8d-6";
export var md = "_8d-5";
export var presenceDot = "_8d-b";
export var red = "_8d-d";
export var sm = "_8d-4";
export var status = "_8d-a";
export var typingDot = "_8d-h";
export var typingPill = "_8d-g";
export var xl = "_8d-7";
export var xs = "_8d-3";
export var xxl = "_8d-8";
export var xxs = "_8d-2";
export var yellow = "_8d-e";